var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base_location_modal", {
    attrs: { tabs_advanced: _vm.tabs_add },
    scopedSlots: _vm._u([
      {
        key: "location_general_info",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("yelo_general_tab", { attrs: { location: location } })]
        },
      },
      {
        key: "location_categories",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("div", [_vm._v("NOT_READY ")])]
        },
      },
      {
        key: "location_logs",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("div", [_vm._v("NOT_READY ")])]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }